import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterEvent,
} from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { riskLevels } from '../../create-case/ras-form/ras-form.utils';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'filter-cases-new-view',
  templateUrl: './filter-cases-new-view.component.html',
  styleUrls: ['./filter-cases-new-view.component.scss'],
})
export class FilterCasesNewViewComponent implements OnInit {
  routerSuscription: Subscription;
  @Input() view;

  @Input() open = undefined;
  @Input() users;
  @Output() sendToHeaderSearch = new EventEmitter<string>();

  public riskLevels = riskLevels;
  caseTypes;
  date = new Date();
  states = [
    {
      value: 'initial',
      name: 'Abierto',
    },
    {
      value: 'assigned',
      name: 'Asignado',
    },
    {
      value: 'running',
      name: 'En proceso',
    },
    {
      value: 'tobeApproved',
      name: 'Por aprobar',
    },
    {
      value: 'toFinalize',
      name: 'Por finalizar',
    },
  ];
  statesAlert = [
    {
      value: 'initial',
      name: 'Abierto',
    },
    {
      value: 'proceed',
      name: 'Asignado',
    },
    {
      value: 'refused',
      name: 'Rechazado',
    },
  ];

  // Establecer la hora a 23:59:59 y los milisegundos a 999 para obtener el final del día
  today = {
    beging: new Date(new Date().setHours(0, 0, 0, 0)),
    end: new Date(new Date().setHours(23, 59, 59, 999)),
  };
  yesterday = {
    beging: new Date(
      new Date(new Date().setDate(new Date().getDate() - 1)).setHours(
        0,
        0,
        0,
        0
      )
    ),
    end: new Date(
      new Date(new Date().setDate(new Date().getDate() - 1)).setHours(
        23,
        59,
        59,
        999
      )
    ),
  };
  last7Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 7)),
    end: new Date(),
  };
  last30Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 30)),
    end: new Date(),
  };
  dates = // ['Hoy', 'Ayer', 'Últimos 7 días', 'Últimos 30 días'];
    [
      {
        value: this.today,
        name: 'Hoy',
      },
      {
        value: this.yesterday,
        name: 'Ayer',
      },
      {
        value: this.last7Days,
        name: 'Últimos 7 días',
      },
      {
        value: this.last30Days,
        name: 'Últimos 30 días',
      },
    ];
  unitId;
  constructor(
    private readonly fb: FormBuilder,
    private readonly unitsService: UnitsService,
    private readonly route: ActivatedRoute,
    private readonly casesService: CasesService,
    private readonly router: Router,
    private readonly alertService: AlertService
  ) {
    this.unitId = this.route.snapshot.paramMap.get('id');
    this.routerSuscription = this.router.events.subscribe(
      async (event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          this.unitId = route.snapshot.paramMap.get('id');
          this.getCaseTypes();
        }
      }
    );
  }
  form: FormGroup = this.fb.group({
    caseType: [''],
    levelRisk: [''],
    // state: [''],
    date: [''],
    end: [''],
    beging: [''],
    assigned: [''],
    creator: [''],
  });
  ngOnDestroy(): void {
    this.routerSuscription?.unsubscribe();
  }
  ngOnInit() {
    this.getCaseTypes();
  }
  getCaseTypes() {
    this.unitsService.getTypeCases(this.unitId).subscribe({
      next: (caseTypes) => {
        this.caseTypes = caseTypes;
        this.form.controls.caseType.setValue(this.caseTypes[0]._id);
      },
    });
  }
  get openFilter() {
    if (this.open == true) {
      return 'slide-bottom';
    } else if (this.open == false) {
      return 'slide-top';
    } else {
      return 'hide';
    }
  }

  setDays() {
    switch (this.form.value.date) {
      case 'Hoy':
        this.form.controls.beging.setValue(this.date);
        this.form.controls.end.setValue(this.date);
        break;
      case 'Ayer':
        this.form.value.date = {
          beging: this.date.setDate(this.date.getDate() - 1),
          end: new Date(),
        };
        break;
      case 'Últimos 7 dias':
        this.form.value.date = {
          beging: this.date.setDate(this.date.getDate() - 7),
          end: new Date(),
        };
        break;
      case 'Últimos 30 dias':
        this.form.value.date = {
          beging: this.date.setDate(this.date.getDate() - 30),
          end: new Date(),
        };
        break;
    }
    if (this.form.value.date) {
      this.form.controls.beging.setValue(this.form.value.date.beging);
      this.form.controls.end.setValue(this.form.value.date.end);
    }
  }
  search() {
    //this.form.controls.date.setValue(this.date);
    // console.log(this.form.value.date);
    // let date = new Date();
    this.sendToHeaderSearch.emit(this.form.value);

    // if (this.view == 'Case') {
    //   this.casesService.filterDataRas.next(this.form.value);
    // } else if (this.view == 'Alert') {
    //   this.alertService.filterDataAlert.next(this.form.value);
    // }
  }
  cleanFilter() {
    this.form.reset('');
    this.form.controls.levelRisk.setValue('');
    // this.form.controls.state.setValue('');
    this.form.controls.date.setValue('');
    this.form.controls.end.setValue('');
    this.form.controls.beging.setValue('');
    this.form.controls.assigned.setValue('');
    this.form.controls.creator.setValue('');
    this.form.controls.caseType.setValue(this.caseTypes[0]._id);
    this.sendToHeaderSearch.emit(this.form.value);

    // if (this.view == 'Case') {
    //   this.casesService.filterDataRas.next(this.form.value);
    // } else if (this.view == 'Alert') {
    //   this.alertService.filterDataAlert.next(this.form.value);
    // }
  }
}
